import React from "react";

import { AlertCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const ErrorBox = React.forwardRef<HTMLDivElement, { message: string | null }>(
  ({ message = "An error occurred. Please try again." }, ref) => {
    return (
      <>
        {message && (
          <Card ref={ref} className="border-red-500 bg-red-50 text-red-900">
            <CardContent className="flex items-center space-x-2 p-4">
              <AlertCircle className="h-5 w-5 flex-shrink-0" />
              <p className="text-sm font-medium">{message}</p>
            </CardContent>
          </Card>
        )}
      </>
    );
  }
);

export { ErrorBox };
